var app = angular.module('leonardo');

var moveMultipleService = function(BaseRestService) {
  var service = new BaseRestService('move-multiple');
  return service;
};

app.factory('moveMultipleService', ['BaseRestService', moveMultipleService]);